import styled, { css } from "styled-components";
import { Link as RouterLink } from "react-router-dom";
import colors from "styles/colors";

const Flex = styled.div`
  display: flex;
`;

const CenterFlex = styled(Flex)`
  justify-content: center;
  align-items: center;
`;

const Row = styled(Flex)`
  flex-direction: row;
  align-items: center;
`;

const RowSpaceBetween = styled(Row)`
  justify-content: space-between;
`;

const RowFlexStart = styled(Row)`
  justify-content: flex-start;
`;

const FitWidth = styled.div`
  width: 100%;
`;

const Container = styled.div`
  padding: 1em;
`;

const Title = styled.h3`
  margin-top: 0;
`;

const SubTitle = styled.text`
  font-style: italic;
`;

const Links = styled(RouterLink)`
  && {
    text-decoration: none;
    font-size: 12px;
    color: ${({ isActive }) => (isActive ? "#fff" : "#ffffffb3")};
    &:hover {
      color: #fff !important;
      cursor: pointer;
      transform: scale(1.1);
      transition: transform 0.2s ease-in-out;
    }
  }
`;

const UiLink = styled.div`
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    color: ${colors.coreColors.jllRed.accent};
  }
`;

const disabledCSS = styled(css)`
  opacity: 0.5;
  pointer-events: none;
  cursor: none;
`;

const notClickableCSS = styled(css)`
  pointer-events: none;
  cursor: inherit;
`;

export {
  Flex,
  CenterFlex,
  Row,
  RowFlexStart,
  RowSpaceBetween,
  FitWidth,
  Container,
  Title,
  SubTitle,
  Links,
  UiLink,
  disabledCSS,
  notClickableCSS,
};
